<div class="sidenav animated">
  <div class="sidenav__header flex justify-content-space-between align-items-center">
    <div class="sidenav__logo">
      <img src="./assets/images/logo/Logo_simon.svg" />
    </div>
    <div class="sidenav__close">
      <button sim-icon-button (click)="closeSidenav()">
        <sim-icon icon="close2" color="var(--ui-secondary-darker, #3f484d)" />
      </button>
    </div>
  </div>

  <div class="sidenav__body scrollbar">
    <div class="sidenav__apartment flex justify-content-center mobile-hide">
      <space-new-property-upload-image
        class="sidenav__image"
        [imageUrl]="photo()"
        [uploadDisabled]="true"
        [small]="true"
      />
    </div>
    <span class="c_body_regular_bold sidenav__name sim-text-center mobile-hide">{{ apartmentName() }}</span>
    <div class="sidenav__divider"></div>
    <div class="sidenav__menu flex column">
      <layout-sim-sidemenu-item (clicked)="closeSidenav()" icon="union" link="./apartment">
        <div i18n="@@LEFT_PANEL_MENU_3D_WALK_BUTTON">3D Walk</div>
      </layout-sim-sidemenu-item>

      <layout-sim-sidemenu-item (clicked)="closeSidenav()" icon="list" link="./dashboard">
        <div i18n="@@LEFT_PANEL_MENU_3D_DASHBOARD">Dashboard</div>
      </layout-sim-sidemenu-item>

      @if (calendarEnabled()) {
        <ng-container [ngTemplateOutlet]="calendarItem" />
      } @else {
        <sim-tooltip
          class="sidenav__menu-tooltip"
          [tooltip]="publicLinkUnavailable"
          position="right"
          [focusable]="false"
        >
          <ng-container [ngTemplateOutlet]="calendarItem" />
        </sim-tooltip>
      }

      <ng-template #calendarItem>
        <layout-sim-sidemenu-item
          (clicked)="closeSidenav()"
          icon="calendar"
          link="./calendar"
          [isDisabled]="!calendarEnabled()"
        >
          <span i18n="@@LEFT_PANEL_MENU_3D_CALENDAR">Calendar</span>
        </layout-sim-sidemenu-item>
      </ng-template>

      <div class="sidenav__divider"></div>

      <layout-sim-sidemenu-item (clicked)="closeSidenav()" icon="settings" link="./property-settings">
        <div i18n="@@LEFT_PANEL_MENU_3D_SPACE_SETTINGS">Space settings</div>
      </layout-sim-sidemenu-item>

      @if (isPublicModeActive()) {
        <sim-tooltip
          class="sidenav__menu-tooltip"
          [tooltip]="publicLinkUnsupported"
          position="right"
          [focusable]="false"
        >
          <ng-container [ngTemplateOutlet]="providersItem" />
        </sim-tooltip>
      } @else {
        <ng-container [ngTemplateOutlet]="providersItem" />
      }

      <ng-template #providersItem>
        <layout-sim-sidemenu-item
          (clicked)="closeSidenav()"
          icon="hub"
          link="./providers-settings"
          [isDisabled]="isPublicModeActive() || !providersDisabled()"
        >
          <div i18n="@@LEFT_PANEL_MENU_3D_PROVIDERS">Providers</div>
        </layout-sim-sidemenu-item>
      </ng-template>

      @if (interiorDesignerVisible()) {
        @if (isPublicModeActive()) {
          <sim-tooltip
            class="sidenav__menu-tooltip"
            [tooltip]="publicLinkUnsupported"
            position="right"
            [focusable]="false"
          >
            <ng-container [ngTemplateOutlet]="interiorItem" />
          </sim-tooltip>
        } @else {
          <ng-container [ngTemplateOutlet]="interiorItem" />
        }
      }

      <ng-template #interiorItem>
        <layout-sim-sidemenu-item
          (clicked)="closeSidenav()"
          icon="chair"
          link="./interior-designer"
          [isDisabled]="isPublicModeActive()"
        >
          <div i18n="@@LEFT_PANEL_MENU_3D_INTERIOR_EDITOR">Interior editor</div>
        </layout-sim-sidemenu-item>
      </ng-template>

      @if (isPublicModeActive()) {
        <sim-tooltip
          class="sidenav__menu-tooltip"
          [tooltip]="publicLinkUnsupported"
          position="right"
          [focusable]="false"
        >
          <ng-container [ngTemplateOutlet]="documentsItem" />
        </sim-tooltip>
      } @else if (canViewDocuments()) {
        <ng-container [ngTemplateOutlet]="documentsItem" />
      } @else {
        <sim-tooltip
          class="sidenav__menu-tooltip"
          i18n-tooltip="@@LEFT_PANEL_MENU_3D_DOCUMENTS_NO_VIEW_PERMISSION"
          tooltip="Documents disabled. No permissions to view the document panel."
          position="right"
          [focusable]="false"
        >
          <ng-container [ngTemplateOutlet]="documentsItem" />
        </sim-tooltip>
      }

      <ng-template #documentsItem>
        <layout-sim-sidemenu-item
          (clicked)="closeSidenav()"
          icon="insert_drive_file"
          link="./documents"
          [isDisabled]="isPublicModeActive() || !canViewDocuments()"
        >
          <div i18n="@@LEFT_PANEL_MENU_3D_DOCUMENTS">Documents</div>
        </layout-sim-sidemenu-item>
      </ng-template>

      @if (stagesVisible()) {
        <layout-sim-sidemenu-item
          (clicked)="closeSidenav()"
          imageSrc="./assets/images/logo/logo_stages.svg"
          link="./stages"
        >
          <div i18n="@@LEFT_PANEL_MENU_3D_STAGES">Stages</div>
        </layout-sim-sidemenu-item>
      }

      @if (!isPublicModeActive()) {
        <div class="sidenav__divider"></div>

        <layout-sim-sidemenu-item (clicked)="closeSidenav()" icon="grid" link="split-view">
          <div i18n="@@LEFT_PANEL_MENU_3D_BROWSE_SPACES">My spaces</div>
        </layout-sim-sidemenu-item>
      }
    </div>
  </div>
</div>
